import { shoppingCartRemove } from "./shoppingCartRemove";
import { storeShoppingCart } from "./storeShoppingCart";

export const handleCartDeleteItem = (shoppingCartString: string, productId: string, setStateFn: Function) => {
  const newShopingCartString = shoppingCartRemove(shoppingCartString, productId);
  setStateFn(newShopingCartString);
  storeShoppingCart(newShopingCartString);
}